// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__18nhq","label":"styles_label__3k7e2"};